/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProviderEnum } from './cloudProviderEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { VcdsPersonaEnum } from './vcdsPersonaEnum';
import { ReleaseTypeEnum } from './releaseTypeEnum';


export interface UpdateReleaseCapabilitySpec { 
    /**
     * Version String for a release
     */
    version: string;
    service_type: ServiceTypeEnum;
    release_type: ReleaseTypeEnum;
    cloud_provider?: CloudProviderEnum;
    persona?: VcdsPersonaEnum;
    /**
     * Mapping of the capability name to its value
     */
    capabilities: { [key: string]: string; };
    operation: UpdateReleaseCapabilitySpec.OperationEnum;
}
export namespace UpdateReleaseCapabilitySpec {
    export type OperationEnum = 'ADD' | 'UPDATE' | 'REMOVE';
    export const OperationEnum = {
        ADD: 'ADD' as OperationEnum,
        UPDATE: 'UPDATE' as OperationEnum,
        REMOVE: 'REMOVE' as OperationEnum
    };
}


